import { Query } from "react-apollo"
import { FIND_BLOG } from "../queries"
import Loading from "../../shared/Loading";
import React from "react";
import { useRouteMatch } from "react-router";
import EditBlogContent from "./EditBlogContent";
import { isAdmin } from "../../../utils/localStorage";
import { locationString } from "../../../utils";

const EditBlogIndex = () => {
        
    const match = useRouteMatch();
    const id = match.params.id;
    const region = match.params.region;

    const idCheck = (id) => {
        //checks if numeric
        return (/^\d+$/.test(id))
    }

    const AdminCheck = () => {
        if (isAdmin()){
            return(
                <Query query={FIND_BLOG} variables={{blogId: idCheck(id)?id:null,
                                                    blogTitle:idCheck(id)?null:id,
                                                    city: locationString(region)}}>
                    {({ loading, error, data, refetch }) => {
                        if (loading)
                            return (
                                <div className="load-div">
                                    <Loading size="3x" />
                                </div>
                            );
                        if (data){
                            return (
                                <EditBlogContent blog={data && data.findBlog}/>
                            )
                        }
                    }}
                </Query>
            )
        }
        else{
            return(
                <div>Forbidden Page</div>
            )
        }
    }

    return(
        AdminCheck()
    )
}

export default EditBlogIndex;


// WEBPACK FOOTER //
// ./src/components/Blogs/EditBlog/index.js